import React, { memo } from 'react';

const MarketingCampaigns = memo((props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={144} height={144} fill="none" {...props}>
        <mask
            id="marketing-campaigns-mask"
            width={122}
            height={98}
            x={11}
            y={23}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M132.424 23.153H11.859v97.694h120.565V23.153Z" />
        </mask>
        <g mask="url(#marketing-campaigns-mask)">
            <path
                fill="#00D639"
                d="M132.424 62.087 86.144 27.97a23.395 23.395 0 0 0-27.706 0l-46.58 34.117v55.173h120.566V62.087Z"
            />
            <path
                fill="#ABABAB"
                d="M37.482 67.789 35.74 82.57l33.344 15.093-.273-40.407-18.021-1.18-13.308 11.712Z"
            />
            <path
                fill="#ABABAB"
                d="M57.207 84.014c5.037 0 9.12-4.08 9.12-9.113 0-5.033-4.083-9.113-9.12-9.113-5.037 0-9.12 4.08-9.12 9.113 0 5.033 4.083 9.113 9.12 9.113Z"
            />
            <path
                fill="#ABABAB"
                d="M69.291 53.868c0 6.7-5.435 12.13-12.14 12.13-6.705 0-12.14-5.43-12.14-12.13 0-6.699 5.49-5.214 12.195-5.214 6.706 0 12.087-1.485 12.087 5.214h-.002Z"
            />
            <path
                fill="#ABABAB"
                d="m66.222 76.292-18.055-.165-3.094-21.047 24.16-.012-3.011 21.224Z"
            />
            <path
                fill="#E84D4F"
                d="M50.277 38.586a4.143 4.143 0 0 0 4.145-4.142 4.143 4.143 0 0 0-4.145-4.142 4.143 4.143 0 0 0-4.145 4.142 4.143 4.143 0 0 0 4.145 4.142Z"
            />
            <path
                fill="#5E5E5E"
                d="M132.422 62.16v56.083a2.593 2.593 0 0 1-.871 1.943 2.596 2.596 0 0 1-1.734.661H14.465a2.595 2.595 0 0 1-1.608-.556 2.538 2.538 0 0 1-.527-.555 2.579 2.579 0 0 1-.471-1.493V62.087L61.726 86.32a24.158 24.158 0 0 0 4.47 1.654 24.11 24.11 0 0 0 16.659-1.654l49.567-24.158Z"
            />
            <path
                fill="#ABABAB"
                d="M41.843 90.419c-4.305 0-8.734-2.364-11.614-6.213-3.204-4.283-4.056-9.835-2.336-15.23 1.086-3.405 3.526-9.535 4.871-12.65 4.051-9.385 13.562-15.624 24.234-15.893a8.229 8.229 0 0 1 8.438 8.015c.115 4.543-3.477 8.316-8.022 8.431-4.272.108-8.013 2.447-9.53 5.96-1.176 2.726-3.436 8.416-4.3 11.129a4.682 4.682 0 0 0-.046.157c3.702.739 6.526 3.963 6.61 7.89.097 4.543-3.51 8.303-8.055 8.4-.082.002-.166.004-.25.004Z"
            />
            <path
                fill="#ABABAB"
                d="M92.61 63.694c-6.143 0-12.027-1.388-15.48-2.395-.87-.253-1.716-.501-2.538-.742-10.945-3.208-15.991-4.559-20.909-2.934-4.317 1.427-8.974-.914-10.402-5.226-1.428-4.314.915-8.967 5.23-10.394 10.001-3.305 18.69-.758 30.716 2.767.813.238 1.648.483 2.507.733 4.91 1.43 9.717 2.015 13.12 1.618a8.23 8.23 0 0 1 7.578-8.189c4.533-.363 8.501 3.016 8.863 7.545.064.809.186 3.699-.973 6.944-1.844 5.163-6.038 8.711-11.507 9.733-2.041.381-4.139.538-6.204.538v.002Zm2.27-15.93c0 .008 0 .017.002.026 0-.01 0-.018-.002-.027Zm0-.007v.006-.006Z"
            />
            <path
                fill="#E84D4F"
                d="M104.255 48.511a4.115 4.115 0 0 1-4.081-4.7c.5-3.464 2.26-15.025 3.967-18.398a4.117 4.117 0 0 1 5.531-1.816 4.111 4.111 0 0 1 1.817 5.527c-.742 1.505-2.238 9.417-3.167 15.862a4.116 4.116 0 0 1-4.069 3.527l.002-.002Z"
            />
            <path
                fill="#E84D4F"
                d="M103.106 37.182a1.495 1.495 0 0 1-1.466-1.805c.704-3.325-.568-6.36-.58-6.39a1.497 1.497 0 0 1 2.747-1.188c.068.157 1.669 3.91.761 8.196a1.495 1.495 0 0 1-1.462 1.186v.002Z"
            />
            <path
                fill="#474747"
                d="M132.038 119.606a2.629 2.629 0 0 1-.486.58L78.386 87.973l-6.094-3.691-6.094 3.691-53.34 32.318a2.536 2.536 0 0 1-.527-.555l52.883-32.04 7.078-4.29 7.077 4.29 52.669 31.91Z"
            />
            <path
                fill="#E84D4F"
                d="M63.74 90.067c-10.26 0-18.278-2.607-18.76-2.767a4.113 4.113 0 1 1 2.597-7.806c.142.046 14.97 4.818 28.726.59a4.116 4.116 0 0 1 5.145 2.721 4.112 4.112 0 0 1-2.724 5.141c-5.126 1.577-10.29 2.123-14.985 2.123l.002-.002Z"
            />
        </g>
    </svg>
));

export default MarketingCampaigns;
